import React from 'react';
import { Icon } from 'ui';
import CriterionCountPerRating from './CriterionCountPerRating';

const CriterionRow = props => {
  const { criterion } = props;

  return (
    <tr className="CriterionRow">
      <td className="d-f">
        {criterion.name}
        <div
          className="ml-4"
          data-toggle="tooltip"
          title={
            criterion.description || t('insights.criterion.no_description')
          }
          data-placement="top"
        >
          <Icon name="info" className="c-brand-gray-dark" />
        </div>
      </td>
      <td>{criterion.data.total}</td>
      <td>
        <CriterionCountPerRating data={criterion.data.countPerStarRating} />
      </td>
    </tr>
  );
};

export default CriterionRow;
